import RootReducer from "./_reducers/rootReducer";
import {configureStore} from "@reduxjs/toolkit";

// Store contains all the implementation of reducers ready to be exported to provider of the application
const store = configureStore({
    reducer: RootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
    devTools: false,
})

export default store;
